import React, { useState, useEffect } from 'react';
import { IoCloseOutline } from "react-icons/io5";
import { CiFileOn } from "react-icons/ci";
import { ToastContainer, toast } from 'react-toastify';
import { apiCallingPost } from "../api/services";
import axios from "axios";
let validFiles = [];

function VideoMultipleUpload(props) {
  let [cloudFolderName, configData, cloudBucketName, file_folder] = []
  const [files, setFiles] = useState([]);
  const [showListFlag, setShowListFlag] = useState(false);
  const [buttonData, setButtonData] = useState("Upload And Save");
  const [uploadProgress, setUploadProgress] = useState({}); // Track progress for each file
  const [isDragOver, setIsDragOver] = useState(false);
  const [signedUrls, setSignedUrls] = useState({});
  const [isImporting, setIsImporting] = useState("");
  const [offLineFlag, setOffLineFlag] = useState("");
  const [isUploadFlag, setIsUploadFlag] = useState(true)

  useEffect(() => {
    setIsUploadFlag(true)
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };

    const handleOffline = () => {
      toast.error("You are offline. Upload will resume when online.");
      setOffLineFlag(true)
    };

    const handleOnline = () => {
      toast.success("Back online! Resuming uploads...");
      setOffLineFlag(true)
      resumeUpload();
    };

    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("online", resumeUpload);
    };
  }, []);

  const resumeUpload = () => {
    const storedUpload = JSON.parse(localStorage.getItem("pending_upload"));
    if (storedUpload && storedUpload.length > 0) {
      const newUploadProgress = {};
      const filesFromStorage = storedUpload.map((stored) => {
        const matchingFile = validFiles.find((file) => file.name === stored.fileName);
        if (matchingFile) {
          return matchingFile;
        }
        return null;
      }).filter(Boolean);
      setFiles(filesFromStorage);
      setShowListFlag(true);
      // Resume uploads for each file
      storedUpload.forEach((storedFile) => {
        const matchingFile = filesFromStorage.find((file) => file.name === storedFile.fileName);
        if (matchingFile) {
          if (storedFile.success) {
            newUploadProgress[storedFile.fileName] = "Success";
          } else {
            const progress = Math.round((storedFile.progress / storedFile.size) * 100);
            newUploadProgress[storedFile.fileName] = `${progress}%`;
            // Resume upload from last saved position
            uploadChunks(
              matchingFile,
              storedFile.filePath,
              storedFile.url,
              storedFile.progress
            );
          }
        }
      });
      setUploadProgress(newUploadProgress);
    }
  };

  const handleDrop = async (event) => {
    console.log("...event..........",event);
   // validFiles = []
    event.preventDefault();
    setIsDragOver(false);
    const droppedFiles = Array.from(event.dataTransfer.files);
    console.log("...droppedFiles..........",droppedFiles);

     validFiles = await handleFileValidation(droppedFiles);
    console.log("...validFiles..........",validFiles);

    if (validFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
      setShowListFlag(true);
    } else {
      toast.error("No valid files to upload.");
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleFileValidation = async (selectedFiles) => {
    let validFiles = [];
    for (const file of selectedFiles) {
      validFiles.push(file);
    }
    return validFiles;
  };

  const handleFileSelection = async (event) => {

    setButtonData("Upload And Save");
    localStorage.removeItem("pending_upload");
    setSignedUrls({})
    setUploadProgress({})
    const selectedFile = Array.from(event.target.files);
    event.target.value = null;
    validFiles = [];
    let pendingUploads = [];

    for (const file of selectedFile) {
      if (file.type.startsWith("video/")) {
        try {
          validFiles.push(file);
          pendingUploads.push({
            fileName: file.name,
            fileType: "2", // video type
            progress: 0,
            success: false,
            size: file.size,
            validated: true,
            // Do not include the file object here
          });
        } catch (error) {
          toast.error(error);
        }
      } else if (file.type.startsWith("image/")) {
        validFiles.push(file);
        pendingUploads.push({
          fileName: file.name,
          fileType: "1", // image type
          progress: 0,
          success: false,
          size: file.size,
          validated: true,
          // Do not include the file object here
        });
      } else {
        toast.error(`${file.name} is not a valid video or image file.`);
      }
    }

    if (validFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
      setShowListFlag(true);

      localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));
    }
  };

  const processFileUpload = async (file, index) => {
    try {
      let signedUrl = signedUrls[file.name];
      let filePath;
      let result;

      if (!signedUrl) {
        let fileName = `${file?.name?.replaceAll(" ", "_").replaceAll("'", "").replaceAll(`"`, "")}`;
        const dotIndex = fileName.lastIndexOf(".");
        const namePart = fileName.substring(0, dotIndex);
        const extension = fileName.substring(dotIndex);
        fileName = `${namePart}_${new Date().getTime()}${extension}`;
        [cloudFolderName, configData, cloudBucketName, file_folder] = [
          props.getCloudBucketData.find(item => item.id === 7)?.config_value,
          props.getCloudBucketData.find(item => item.id === 14)?.config_value,
          props.getCloudBucketData.find(item => item.id === 5)?.config_value,
          props.getCloudBucketData.find(item => item.id === 18)?.config_value
        ];
        filePath = `${cloudFolderName}/${configData}/${file_folder}/${fileName}`;
        const postData = { fileName: filePath };

        const response = await apiCallingPost("api/common/generateResumableUrl", postData);

        if (response.data.success === "1") {
          result = response.data.result;
          signedUrl = result.signedUrl;
          setSignedUrls((prev) => ({ ...prev, [file.name]: signedUrl }));
          return {
            fileName: file.name,
            filePath,
            progress: 0,
            cloudBucketName: cloudBucketName,
            url: result,
            size: file.size,
            fileType: file.type.startsWith("video/") ? "2" : "1",
            validated: true,
          };
        } else {
          throw new Error("Failed to generate signed URL.");
        }
      }
    } catch (error) {
      toast.error(`Error processing ${file.name}: ${error.message}`);
      throw error; // Re-throw the error to handle it in the calling function
    }
  };

  const importData = async () => {
    setIsImporting("true"); // Indicate the upload has started
    setButtonData("Uploading...")
    console.log(".....validFiles.........",validFiles);
    
    const newUploadProgress = {};
    validFiles.forEach((file) => {
      newUploadProgress[file.name] = "Uploading...";
    });
    console.log("...newUploadProgress....",newUploadProgress);
    
    setUploadProgress(newUploadProgress);

    try {
      // Generate signed URLs for all files first
      const pendingUploads = await Promise.all(validFiles.map((file, index) => processFileUpload(file, index)));
    console.log("...pendingUploads....",pendingUploads);
     
      // Set pending_upload in localStorage after all signed URLs are generated
      localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));
      uploadData()

      // Upload the main file to cloud storage
      await Promise.all(pendingUploads.map((data, index) => uploadChunks(validFiles[index], data.filePath, data.url, 0)));
    } catch (error) {
      setIsImporting("true");
      toast.error(`Unexpected error during import: ${error.message}`);
    }
  };
  const uploadChunks = async (file, filePath, uploadUrl, startByte = 0) => {
    let progress = "";
    const CHUNK_SIZE = 5 * 1024 * 1024;
    if (file.size <= CHUNK_SIZE) {
      try {
        await axios.put(uploadUrl.signedUrl, file, {
          headers: { "Content-Type": file.type },
          onUploadProgress: ({ loaded, total }) => {
            progress = Math.round((loaded * 100) / total);
            setUploadProgress((prev) => ({ ...prev, [file.name]: `${progress}%` }));
          },
        });

        let pendingUploads = JSON.parse(localStorage.getItem("pending_upload")) || [];
        pendingUploads = pendingUploads.map((item) => {
          if (item.fileName === file.name) {
            setUploadProgress((prev) => ({ ...prev, [file.name]: "Success" }));
            return {
              ...item,
              progress: file.size,
              progressPercentage: progress,
              success: progress === 100,
              size: file.size // Ensure size is stored
            };
          }
          return item;
        });
        localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));      
        checkAllUploadsComplete();
      } catch (error) {
        if (!navigator.onLine) {
          return;
        }
        setUploadProgress((prev) => ({ ...prev, [file.name]: "Failed" }));
        toast.error(`Error uploading ${file.name}: ${error.message}`);
        return;
      }
    }

    else {
      let start = startByte;
      while (start < file.size) {
        const end = Math.min(start + CHUNK_SIZE, file.size);
        const chunkBlob = file.slice(start, end);
        try {
          const res = await fetch(uploadUrl.signedUrl, {
            method: "PUT",
            headers: {
              "Content-Type": "application/octet-stream",
              "Content-Range": `bytes ${start}-${end - 1}/${file.size}`,
            },
            body: chunkBlob,
          });

          if (res.ok || res.status === 308) {
            start = end;
            progress = Math.round((start / file.size) * 100);
            setUploadProgress((prev) => ({ ...prev, [file.name]: `${progress}%` }));

            // Update storage after each successful chunk
            let pendingUploads = JSON.parse(localStorage.getItem("pending_upload")) || [];
            pendingUploads = pendingUploads.map((item) => {
              if (item.fileName === file.name) {
                item.size === start && setUploadProgress((prev) => ({ ...prev, [file.name]: "Success" }));
                return {
                  ...item,
                  progress: start,
                  progressPercentage: progress,
                  success: progress === 100,
                  size: file.size // Ensure size is stored
                };
              }
              return item;
            });
            localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));
            // if (pendingUploads.progress === pendingUploads.size) {
            //   setUploadProgress((prev) => ({ ...prev, [file.name]: "loading..." }));
            // }
            checkAllUploadsComplete();
          } else {
            throw new Error(`Upload failed: ${res.statusText}`);
          }
        } catch (error) {
          if (!navigator.onLine) {
            return;
          }
          setUploadProgress((prev) => ({ ...prev, [file.name]: "Failed" }));
          toast.error(`Error uploading ${file.name}: ${error.message}`);
          return;
        }
      }
    }
  };
  const checkAllUploadsComplete = () => {
    let pendingUploads = JSON.parse(localStorage.getItem("pending_upload")) || [];
    const allUploaded = pendingUploads.every((file) => file.progress === file.size && file.success === true);

    if (allUploaded) {
      setButtonData("Loading...")
      toast.success("Data uploaded successfully.");
      setTimeout(() => {
        cancelPopup()
      }, 1000);
      props.videoListFn()
      localStorage.removeItem("pending_upload")
      // uploadData()
    }
  };
  const uploadData = async () => {
    const pendingUploads = JSON.parse(localStorage.getItem("pending_upload") || "[]");
    let videoUrl = []; // Initialize as an array
    let fileTitle = "";
    for (const data of pendingUploads) {
      fileTitle = data.fileName.substring(0, data.fileName.lastIndexOf("."));
      const cloudStorageLink = "https://storage.googleapis.com"
      const result = {
        videoUrl: `${cloudStorageLink}/${data.cloudBucketName}/${data.filePath}`,
        fileTypeId: data.fileType,
        fileName: fileTitle,
      };
      videoUrl.push(result); // Push the result into the array
    }
    console.log("...videoUrl....",videoUrl);

    if (videoUrl?.[0] == null || videoUrl?.[0] == undefined) {
      // Handle the case where no valid URLs were generated
    } else {
      SaveData(videoUrl);
    }
  };

  const SaveData = async (videoUrlArray) => {
    console.log("..videoUrlArray.....",videoUrlArray);
    
    const postData = {
      videoName: "",
      videoUrl: videoUrlArray,
      userId: props.userData.userId,
      createdBy: props.userData.userId,
      videoDescription: "",
      processedBy: props.userData.userId,
      roleName: props.userData.roleDisplayName,
      videoLocation: "",
      videoDate: ""
    };
    console.log("..postData.....",postData);
    
    try {
      apiCallingPost("api/video/uploadVideo", postData);
    } catch (error) {
      toast.error(`Error uploading data: ${error.message}`);
    }
  }

  const deleteFile = (data, index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setUploadProgress((prev) => {
      const updatedProgress = { ...prev };
      delete updatedProgress[index];
      return updatedProgress;
    });
    let pendingUploads = JSON.parse(localStorage.getItem("pending_upload")) || [];
    pendingUploads = pendingUploads.filter((upload, i) => i !== index);
    localStorage.setItem("pending_upload", JSON.stringify(pendingUploads));

  };

  const clickEvent = () => {
    if (buttonData == "Upload And Save") {
      importData()
    }
  }

  const cancelPopup = () => {
    setShowListFlag(false);
    setFiles([])
    setUploadProgress({})
    setIsUploadFlag(props.isDragFile)
    props.setIsDragFile(false)
  }

  return (
    <>


      {/* <div style={{display : isUploadFlag ? 'block' : 'none'}} className="modal-admin-wrapper multiple-upload">
        <div className="modal-ad-popup modal-md"> */}

      {showListFlag ? (
        <div className="modal-admin-wrapper multiple-upload">
          <div className="modal-ad-popup modal-md">
            <div className="modal-innerpopup">
              <div className="modal-headdiv d-flex justify-content-between">
                <h5 className="modal-head">Import Files</h5>
                <span className="closeBtn">
                  <IoCloseOutline onClick={() => cancelPopup()} size={32} />
                </span>
              </div>
              <div className="modal-admin-body">
                <div className="mutliple-upload-files">
                  {files.map((file, index) => (
                    <div className="row my-1 mx-0 border-line" key={index}>
                      <div className="col-8 col-lg-9">
                        <div className="d-flex align-items-center file-name">
                          <CiFileOn fontSize={23} className='file-ico ms-0' />
                          <span className="file-names">{file.name}</span>
                        </div>
                      </div>
                      <div className="col-4 col-lg-3 d-flex align-items-center justify-content-end">
                        {uploadProgress[file.name] ? (
                          <div className={`file-size me-3 text-primary text-sm ${uploadProgress[file.name] === "Failed"
                            ? "text-danger"
                            : uploadProgress[file.name] === "Success"
                              ? "text-success"
                              : ""
                            }`}>
                            {uploadProgress[file.name]}
                          </div>
                        )
                          : (
                            <IoCloseOutline size={20} onClick={() => deleteFile(file, index)} />
                          )
                        }
                      </div>
                    </div>
                  ))}

                </div>
                <div className="text-end">
                  <button className="btn btn-primary" onClick={clickEvent} id="Save"
                    disabled={buttonData === "Uploading..." || buttonData === "Loading..."}>
                    {buttonData}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        isUploadFlag && (
          <div style={{ display: isUploadFlag ? 'block' : 'none' }} className="modal-admin-wrapper multiple-upload">
            <div className="modal-ad-popup modal-md">
              <div className={`file-upload-list ${isDragOver ? 'drag-over' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}>
                <span className="closeBtn  closeBtn_file">
                  <IoCloseOutline onClick={() => cancelPopup()} size={26} />
                </span>
                <div className="box__input">
                  <input
                    type="file"
                    name="files[]"
                    id="file"
                    className="box__file"
                    multiple
                    onChange={(e) => { handleFileSelection(e) }}
                  />
                  <label htmlFor="file">
                    <span>Drag Files</span>
                    <span className="box__dragndrop">
                      <div>Or</div>
                      <span className='text-underline'> Click To Upload</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>))}
      {/* </div>
      </div> */}

    </>
  );
}

export default VideoMultipleUpload;
